import React, { useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { ColumnValue, FundChildrenDataValues, FundChildrenItems, Menu } from './style';
import { DeleteIcon, TrashIcon } from './icons';

const RenderColumns = ({
  table,
  rows,
  index,
  style,
  onDeleteSelectedCell,
  action,
  onFocusLocation,
  onDeleteRow,
  isIndividualFund
}) => {
  const [isVisible, setIsVisible] = useState('');

  const handleContextMenu = (e, value) => {
    e.preventDefault();
    setIsVisible(value);
  };

  const onClose = () => {
    setIsVisible(false);
  };

  const handleDeleteRowFromPopover = rowItem => {
    onDeleteRow(rowItem, table.id);
    onClose();
  };

  const handleCellFocusLocation = (rowIndex, columnIndex) => {
    onFocusLocation({
      rowIndex,
      columnIndex: columnIndex
    });
  };

  const handleDeleteCell = (e, cellIndex, cellValueId) => {
    e.stopPropagation();
    onDeleteSelectedCell(cellIndex, table.id, cellValueId);
  };

  const getNullCoordinateFallback = column => {
    const isNullCoordinateColumn = column.values.every(v => !rows.includes(v.rowId));
    const positionalValue = column.values[index - 1];
    return isNullCoordinateColumn && positionalValue?.text != null ? (
      <p>{String(positionalValue.text)}</p>
    ) : null;
  };

  return (
    <FundChildrenItems
      id={`grid-table-sidebar-rows-${table.id}-${index}`}
      isMultipleItems={table.columns.length > 2}
      style={style}
      key={index + 'rows'}
    >
      <div id={`grid-table-sidebar-row-index-${table.id}-${index}`} className="delete-btn">
        {index}
      </div>
      {table.columns.map((value, ind) => {
        const isFundName = value.id === 'fund name';
        const isVertical = rows[index - 1] === '__vertical__';
        const cellIndex = isVertical
          ? value.values.findIndex(val => val.rowId && val.columnId)
          : value.values.findIndex(val => val.rowId === rows[index - 1]);
        const deleteRowId = isVertical ? value.values[cellIndex]?.rowId : rows[index - 1];

        return cellIndex >= 0 ? (
          <Popover
            isOpen={isVisible === `${ind}-column-${table.id}-${value.id}`}
            onClickOutside={onClose}
            positions={['bottom', 'top', 'left', 'right']}
            padding={0}
            key={`${ind}-column-${table.id}-${value.id}`}
            content={
              <Menu>
                <div
                  id={`grid-table-sidebar-delete-row-option-${table.id}-${deleteRowId}`}
                  className="option"
                  onClick={() => handleDeleteRowFromPopover(deleteRowId)}
                >
                  <TrashIcon />
                  Delete row
                </div>
              </Menu>
            }
          >
            <ColumnValue
              id={`grid-table-sidebar-cell-${table.id}-${value.id}-${index}`}
              isMultipleItems={table.columns.length > 2}
              key={value.id + index}
              onClick={() =>
                handleCellFocusLocation(
                  value.values[cellIndex].rowId,
                  value.values[cellIndex].columnId
                )
              }
              onContextMenu={e => handleContextMenu(e, `${ind}-column-${table.id}-${value.id}`)}
            >
              <FundChildrenDataValues>
                <p>
                  {value.values[cellIndex]?.text != null
                    ? String(value.values[cellIndex].text)
                    : ''}{' '}
                </p>
                {value.values[cellIndex].rowId !== null && action === 'Manual' && (
                  <span onClick={e => handleDeleteCell(e, cellIndex, value.id)}>
                    <DeleteIcon
                      id={`grid-table-sidebar-delete-cell-${table.id}-${value.id}-${index}`}
                    />
                  </span>
                )}
              </FundChildrenDataValues>
            </ColumnValue>
          </Popover>
        ) : (
          <ColumnValue
            id={`grid-table-sidebar-cell-empty-${table.id}-${value.id}-${index}`}
            isMultipleItems={table.columns.length > 2}
            key={value.id + index}
          >
            <FundChildrenDataValues>
              {isIndividualFund && isFundName ? (
                <p>{value.values[index - 1]?.text}</p>
              ) : (
                getNullCoordinateFallback(value)
              )}
            </FundChildrenDataValues>
          </ColumnValue>
        );
      })}
    </FundChildrenItems>
  );
};

export default React.memo(RenderColumns);
